import { Component, HostListener, inject } from '@angular/core';
import { CookieBannerComponent } from '../../generic/component/cookies/cookie.banner.component';
import { CookieService } from '../../generic/service/cookie.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'scroll-to-top',
    templateUrl: 'scroll.to.top.component.html',
    styleUrls: ['./scroll.to.top.component.scss'],
    standalone: true,
    imports: [NgClass],
})
export class ScrollTopComponent {
    private cookieService = inject(CookieService);

    showButton: boolean;

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.showButton = !!(
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop > 100
        );
    }

    hasAcceptedCookies(): boolean {
        return this.cookieService.getCookieByName(
            CookieBannerComponent.ACCEPTED_COOKIES,
        );
    }

    hasHiddenCookieBanner(): boolean {
        return this.cookieService.getCookieByName(
            CookieBannerComponent.HIDE_COOKIE_BANNER_NAME,
        );
    }

    acceptedCookies(): boolean {
        if (this.hasAcceptedCookies() === undefined) {
            return false;
        }

        return this.hasAcceptedCookies() || this.hasHiddenCookieBanner();
    }

    scrollToTop() {
        const isAtLeastIE11 = !!(
            navigator.userAgent.match(/Trident/) &&
            !navigator.userAgent.match(/MSIE/)
        );

        (function smoothscroll() {
            const currentScroll =
                document.documentElement.scrollTop || document.body.scrollTop;
            if (currentScroll > 0) {
                if (isAtLeastIE11) {
                    window.scrollTo(0, 0);
                    return;
                }

                window.requestAnimationFrame(smoothscroll);
                window.scrollTo(0, currentScroll - currentScroll / 10);
            }
        })();
    }
}
